import { makeStyles } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'

import Context from '../../context'
import { getProductsList } from '../../services/ClippingApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

function ClippingDetails({ location }) {
  const { clippingDetails, clippingPartnerDetails } = location.state
  const { setUser, setAboutCurrentPage } = useContext(Context)

  const [images, setImages] = useState([])
  const [link, setLink] = useState(null)
  const [products, setProducts] = useState([])
  const [product, setProduct] = useState('')
  const classes = useStyles()

  useEffect(() => {
    if (!isAuthenticated) return history.replace('/')

    let user = getLoggedUser()
    setUser(user)
    setAboutCurrentPage({
      title: `Clipping: ${clippingDetails.title}`,
      buttons:
        user.userGroup === 1
          ? [
              {
                pathname: '/clippingform',
                title: 'Editar',
                state: { clippingToEdit: clippingDetails }
              },
              {
                title: 'Voltar',
                pathname: '/clippingpartner',
                state: { clippingPartnerDetails }
              }
            ]
          : undefined,
      showBackButton: user.userGroup !== 1
    })
    getProductsList().then(r => setProducts([...r]))
    setImages(clippingDetails.ClippingContents.filter(item => item.typeClipping !== 2))
    setLink(clippingDetails.ClippingContents.find(item => item.typeClipping === 2)?.value || '')
  }, [])

  useEffect(() => {
    const newItem = products.find(item => item.id === clippingDetails.clippingProductsId)
    if (newItem) setProduct(newItem.name)
  }, [products])

  return (
    <div className={classes.outerContainer}>
      <div className={classes.content}>
        <img src={clippingDetails.cover} className={classes.cover} />
        <span className={classes.productAndItems}>
          {product} -{' '}
          {clippingDetails.ClippingContents.length === 1
            ? 'um item'
            : `${clippingDetails.ClippingContents.length} itens`}
        </span>
        {link && (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <h4>{link}</h4>
          </a>
        )}
        <p className={classes.description}>{clippingDetails.description}</p>
        {images.map(item => (
          <div key={item.id} className={classes.item}>
            {!item.value?.includes('.pdf') && !item.value?.includes('.mp4') ? (
              <img style={{ width: '100%', height: 'auto' }} src={item.value} alt={item.id} />
            ) : (
              <iframe
                title={item.id}
                src={item.value}
                style={{ width: '100%', minHeight: '700px' }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '40px 45px'
  },
  cover: {
    width: '40%',
    height: 'auto',
    padding: '5px',
    border: '1px solid #f7f7f7',
    borderRadius: '4px',
    boxShadow: '0 0 4px #0004'
  },
  productAndItems: {
    margin: '30px 0 0',
    fontSize: '20px',
    fontWeight: 'bold'
  },
  description: {
    margin: '5px 0 0',
    fontSize: '14px',
    fontStyle: 'italic'
  },
  item: {
    width: '40%',
    margin: '50px 0 0',
    padding: '10px',
    backgroundColor: '#eee'
  }
})

export default ClippingDetails
